/**
 * @module components\subroute\Others\LocateAgents
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class LocateAgents extends Vue {
  data: any = {};
  states: any = [];
  cities: any = [];
  names: any = [];
  state: any = "";
  created() {
    fetch("/data/states.json")
      .then(res => res.json())
      .then(data => {
        this.states = data;
      });
  }
  onStateChange(state: any) {
    this.names = [];
    this.state = state;
    if (!this.data[state]) {
      fetch(`/data/${state}.json`)
        .then(res => res.json())
        .then(data => {
          this.cities = Object.keys(data).sort();
          this.data = { [state]: data, ...this.data };
        });
    } else {
      this.cities = Object.keys(this.data[state]).sort();
    }
  }
  onCityChange(city: any) {
    this.names = this.data[this.state][city].sort();
  }
}
